import { Grid } from "@mui/material";
import { buscarComboPorCodigo } from "src/services/api-autenticacao.service";
import React, { useEffect, useState } from "react";
import GenericAutoCompleteSelect from "src/components/GenericAutoCompleteSelect";

function GenericCodIbgeInputs(props) {
  const {
    ufGridSize = 4,
    cidadeGridSize = 8,
    error,
    uf,
    helperText,
    inputRef,
    cityValue,
    ...rest
  } = props;
  const [idEstado, setIdEstado] = useState(-2);
  const [ibgeCod, setIbgeCod] = useState();
  const [cidadeCodigoCombo, setCidadeCodigoCombo] = useState(
    "CIDADES" + idEstado
  );

  useEffect(() => {
    fetchFilter()
  }, [uf]);

  const fetchFilter = async () => {

    try {
      if (uf) {
        const matchItem = uf;
        const response = await buscarComboPorCodigo("UF");
        const filter = response.detalhes.itensCombo.find((item) =>
          item.includes(matchItem)
        );

        const idEstadoExtern = parseInt(filter.replace(/^(\d+)\/.*/, "$1"));
        setIdEstado(idEstadoExtern);
        setCidadeCodigoCombo(
          !!idEstadoExtern ? "CIDADES" + idEstadoExtern : "CIDADES-2"
        );
        setIbgeCod(parseInt(cityValue));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // fetchFilter();

  const handleChange = (value) => {
    rest.onChange(undefined);
    setIdEstado(value);
    setCidadeCodigoCombo(!!value ? "CIDADES" + value : "CIDADES-2");
    setIbgeCod(parseInt(cityValue));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={ufGridSize}>
        <GenericAutoCompleteSelect
          codigoCombo={"UF"}
          value={idEstado}
          label={"UF"}
          replaceId={"idEstado"}
          replaceLabel={"descricao"}
          placeholder={"Pesquise estados..."}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={cidadeGridSize}>
        <GenericAutoCompleteSelect
          value={ibgeCod}
          codigoCombo={cidadeCodigoCombo}
          label={"Cidade"}
          replaceId={"codIbge"}
          replaceLabel={"descricao"}
          placeholder={"Pesquise cidades..."}
          noOptionsText={"Escolha um estado."}
          error={error}
          helperText={helperText}
          inputRef={inputRef}
          required
          {...rest}
        />
      </Grid>
    </Grid>
  );
}

export default GenericCodIbgeInputs;
